module.exports = __webpack_public_path__ + "static/options-eda230e987260f72a923e67ac37d99d8.png";